<template>
	<div class="select-build">
		<swiper :options="swiperOptionTop" ref="swiperTop">
			<swiper-slide v-for="(currentBuild, index) in buildOptions" :key="index" class="select-build__container">
				<img :src="currentBuild.cover_image" class="select-build__img img-responsive">
			</swiper-slide>
		</swiper>

		<div class="select-build__switch">
			<general-switch
				class="switch"
				v-model="cpu"
				:jack-color="'#51007A'"
				:jack-secondary-color="'#51007A'"
				first-option="Intel"
				second-option="AMD"
				@input="option => trackAll('Client: CPU Selection', { Property: option })"
			/>
		</div>

		<div class="select-build__selectors">
			<div class="select-build__change-budget-button select-build__change-budget-button__prev">
				-
			</div>
			<promo-sales-timed>
				<template v-slot:originalContent>
					<h5 class="select-build__price">
						<sup>$</sup>{{ build.price }}
						<span class="currency-code">USD</span>
					</h5>
				</template>
				<template>
					<h5 class="select-build__price">
						<sup>$</sup>{{ discountPrice }}
						<span class="holiday-price">${{ build.price }}</span>
					</h5>
				</template>
			</promo-sales-timed>
			<div class="select-build__change-budget-button select-build__change-budget-button__next">
				+
			</div>
		</div>
		<promo-sales-timed>
			<template slot-scope="{ phasesInfo: { currentPhase } }">
				<holiday-savings-msg
					v-if="applyCase"
					:phase="currentPhase"
					text="configurator"
				/>
				<holiday-savings-msg
					v-else
					:phase="currentPhase"
					text="configurator2"
				/>
			</template>
		</promo-sales-timed>
		<div class="select-build__buttons">
			<button @click.prevent="goToConfigureOrCheckout(build, cpu)" class="btn select-build__button select-build__button--purple">
				Configure
			</button>
			<button @click.prevent="goToConfigureOrCheckout(build, cpu, true)" class="btn select-build__button select-build__button--orchid">
				Review &amp; Checkout
			</button>
		</div>
		<div class="select-build__affirm">
			<affirm
				v-if="!POS_MODE && countryCode != 'CA'"
				:price="build.price"
			/>
			<paybright
				v-if="!POS_MODE && countryCode == 'CA'"
				:price="build.price"
			/>
		</div>
		<hr class="step3__divider step3__show-mobile">
	</div>
</template>

<script>
import { heapAnalytics } from "@u/mixins.js";
import { mapState } from "vuex";
import GeneralSwitch from "@c/generals/general-switch";
import Affirm from "@c/generals/affirm";
import Paybright from "@c/generals/paybright";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import PromoSalesTimed from "@/components/promo-sales-timed";
import HolidaySavingsMsg from "@c/generals/holiday-saving-msg";
import { casePromo, promoDiscount } from "@u/helpers";

export default {
	name: "Step3SelectBudget",
	components: {
		Affirm,
		GeneralSwitch,
		Paybright,
		swiper,
		swiperSlide,
		PromoSalesTimed,
		HolidaySavingsMsg
	},
	mixins: [
		heapAnalytics
	],
	props: {
		buildOptions: {
			type: Array,
			required: true
		},
		build: {
			type: Object,
			required: true
		},
		slideIndex: {
			type: [String, Number],
			required: true
		},
		configureOrCheckout: {
			type: Function,
			required: true
		}
	},
	data() {
		return {
			cpu: "Intel",
			swiperOptionTop: {
				navigation: {
					nextEl: ".select-build__change-budget-button__next",
					prevEl: ".select-build__change-budget-button__prev"
				}
			}
		};
	},
	computed: {
		...mapState({
			countryCode: state => state.User.location.country_code
		}),
		buildHasElegiblePrice() {
			return !Number.isNaN(Number(this.build.price)) && Number(this.build.price) >= 1000;
		},
		applyCase() {
			return casePromo(this.build);
		},
		discountPrice() {
			return promoDiscount(this.build.price);
		}
	},
	watch: {
		cpu() {
			this.cpuModel();
		}
	},
	mounted() {
		this.$nextTick(() => {
			const swiperTop = this.$refs.swiperTop.swiper;
			swiperTop.slideTo(this.slideIndex, false);
			swiperTop.on("slideChange", () => {
				this.$emit("current-build", swiperTop.activeIndex);
			});
		});
	},
	methods: {
		cpuModel() {
			this.$emit("cpu-model", this.cpu.toLowerCase());
		},
		goToConfigureOrCheckout(build, cpu, checkout = false) {
			const step = !checkout ? 4 : 5;
			this.trackAll(`Client: CPU on Step ${step}`, { CPU: cpu });
			this.configureOrCheckout(build, checkout);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.select-build {
    .swiper-button-disabled {
        color: gray;
        background-color: #2d2d2d;
    }

    .swiper-container, .swiper-wrapper, .swiper-slide {
        width: 100%;
    }

    .swiper-container {
        display: flex;
        justify-content: center;
    }

    &__img {
        height: 210px;
        max-width: 190px;
        margin: 0 auto;
        object-fit: cover;

        @media (max-width: 991px) {
            height: auto;
            max-width: 260px;
        }

        @media (max-width: 580px) {
            height: auto;
            max-width: 210px;
            max-height: 180px;
        }
    }

    &__selectors {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;

        @media (max-width: 991px) {
            margin-bottom: 20px;
        }

        @media (max-width: 580px) {
            margin-bottom: 10px;
        }
    }

    &__change-budget-button {
        width: 40px;
        height: 40px;
        border-radius: 2px;
        background-color: $oldpurple;
        color: $white;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        outline: none;

        @media (min-width: 767px) and (max-width: 991px) {
            width: 50px;
            height: 50px;
            font-size: 32px;
        }

        @media (max-width: 500px) {
            width: 32px;
            height: 32px;
        }
    }

    &__price {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        color: $white;
        font-size: 30px;
        text-align: center;
        margin: 0;

        sup {
            font-size: 25px;
            top: 0;
            font-weight: 200;
        }

        .currency-code {
            font-size: 14px;
            color: rgba($color: #fff, $alpha: 0.6);
            font-weight: 200;
        }

        .holiday-price {
            font-size: 14px;
            color: $white;
            font-weight: 200;
			text-decoration: line-through;
			margin-left: 3px;
        }
    }

    &__switch {
        margin-top: 25px;
        margin-bottom: 30px;
        text-align: center;

        .switch {
            justify-content: center;
        }

        @media (max-width: 580px) {
            margin-top: 15px;
            margin-bottom: 15px;
        }
    }

    &__buttons {
        max-width: 305px;
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;

        @media (max-width: 991px) {
            background-color: #111111;
            margin-bottom: 0;
            position: fixed;
            bottom: 0;
            z-index: 2;
            width: 100%;
            left: 0;
            flex-direction: row;
            max-width: initial;
            height: 100px;
            align-items: center;
            padding: 0 15px;
        }
    }

    &__button {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 15px;
        color: $white;
        border-radius: 0;
        font-size: 14px;
        letter-spacing: 0.76px;
        padding: 0;

        @media (max-width: 991px) {
            margin-bottom: 0;
            height: 50px;
        }

        @media (min-width: 767px) and (max-width: 991px) {
            margin: 0 30px;
        }

        @media (max-width: 580px) {
            font-size: 12px;
        }

        &:hover {
            background-color: $white;
        }

        &--purple {
            background-color: #640992;

            @media (max-width: 991px) {
                margin-right: 15px;
            }

            &:hover {
                color: #640a92;
            }
        }

        &--orchid {
            background-color: $orchid;

            @media (max-width: 991px) {
                background-color: #640992;
            }

            &:hover {
                color: $black;
            }
        }
    }

    &__affirm {
        color: $white;
        text-align: center;
        margin-bottom: 15px;

        @media (max-width: 991px) {
            display: none;
        }
    }

    .step3__show-mobile {
        display: none;

        @media (max-width: 991px) {
            display: block;
        }

        @media (min-width: 580px) and (max-width: 991px) {
            margin-bottom: 20px;
        }
    }

    .step3__divider {
        @media (max-width: 580px) {
            margin: 0;
        }
    }
}

.select-build::v-deep  {
    .holiday-savings-msg {
        p {
            font-family: 'Akkurat-Normal';
            text-align: center;
            color: #BF4CBF;
            margin-bottom: 15px !important;
			font-weight: bold;
        }
    }
}
</style>